import React from 'react';


export default function CustomHeading(props) {
    return(
        <div style={{'backgroundColor':'#00293B',height:45,'marginTop':20,'marginBottom':20}}>
        <center> <p style={{'color':'white',fontSize:26,fontWeight:'bold',paddingTop:3}}>{props?.title}</p></center>
        </div>
    )
}
// How to use
{/* <CustomHeading title="Orgainzation"/> */}
